import { jsx as _jsx } from "react/jsx-runtime";
import { Button } from "@faire/web--source/slate/Button";
import * as React from "react";
import styled from "styled-components";
export var renderTextAction = function(actionOptions, options) {
    if (!actionOptions) {
        return null;
    }
    var _actionOptions_action_href;
    return /*#__PURE__*/ _jsx(Button, {
        tertiaryColor: options === null || options === void 0 ? void 0 : options.textColor,
        variant: "tertiary",
        onClick: actionOptions.action.onClick,
        linkTo: (_actionOptions_action_href = actionOptions.action.href) !== null && _actionOptions_action_href !== void 0 ? _actionOptions_action_href : actionOptions.action.to,
        target: actionOptions.action.href ? "__blank" : undefined,
        children: actionOptions.text
    });
};
export var renderButtonAction = function(actionOptions) {
    if (!actionOptions) {
        return null;
    }
    var _actionOptions_action_href;
    return /*#__PURE__*/ _jsx(Button, {
        onClick: actionOptions.action.onClick,
        linkTo: (_actionOptions_action_href = actionOptions.action.href) !== null && _actionOptions_action_href !== void 0 ? _actionOptions_action_href : actionOptions.action.to,
        target: actionOptions.action.href ? "__blank" : undefined,
        children: actionOptions.text
    });
};
/**
 * @deprecated Use `@faire/web--source/slate/Button` with `variant="tertiary"` and `tertiaryColor` prop
 * @supersededBy "@faire/web--source/slate/Button/Button#Button"
 * @trackcomponent
 * */ export var ColoredButton = styled(Button).withConfig({
    componentId: "sc-1482e076-0"
})([
    "color:",
    ";text-decoration-color:",
    ";"
], function(props) {
    return props.color;
}, function(props) {
    return props.color;
});
